import fs from 'node:fs'
import { findMainCss } from '@next-adapter/main-css.js'
import { renderAdminShadowInputUtility } from '@next-adapter/templates/renderers/init/scaffolders/tailwind/admin-shadow-input-utility.js'
import { renderAdminThemeBlock } from '@next-adapter/templates/renderers/init/scaffolders/tailwind/admin-theme-block.js'
import { getMissingThemeVars } from './get-missing-theme-vars.js'
import { getSourceLines } from './get-source-lines.js'

export function scaffoldTailwind(
  cwd: string,
  hasSrcDir: boolean,
  namespace = 'admin'
): { file: string | null; appended: boolean } {
  const cssFile = findMainCss(cwd)
  if (!cssFile) {
    return { file: null, appended: false }
  }

  let content = fs.readFileSync(cssFile, 'utf-8')
  let changed = false

  const sourceLines = getSourceLines(namespace, hasSrcDir)
  const missingLines = sourceLines.filter((sl) => !content.includes(sl))
  if (missingLines.length > 0) {
    const lines = content.split('\n')
    let insertIndex = 0
    for (let i = 0; i < lines.length; i++) {
      const trimmed = lines[i]!.trim()
      if (
        trimmed.startsWith('@import') ||
        trimmed.startsWith('@source') ||
        trimmed.startsWith('@plugin')
      ) {
        insertIndex = i + 1
      }
    }
    lines.splice(insertIndex, 0, ...missingLines)
    content = lines.join('\n')
    changed = true
  }

  const themeMatch = content.match(/@theme\s+inline\s*\{/)
  if (themeMatch && themeMatch.index !== undefined) {
    let braceDepth = 0
    let insertPos = -1
    for (let i = themeMatch.index; i < content.length; i++) {
      if (content[i] === '{') braceDepth++
      if (content[i] === '}') {
        braceDepth--
        if (braceDepth === 0) {
          insertPos = i
          break
        }
      }
    }
    if (insertPos !== -1) {
      const existingBlock = content.slice(themeMatch.index, insertPos)
      const varsOnly = getMissingThemeVars(existingBlock).join('\n')
      if (varsOnly) {
        content = `${content.slice(0, insertPos)}${varsOnly}\n${content.slice(insertPos)}`
        changed = true
      }
    }
  } else {
    content = `${content}\n${renderAdminThemeBlock()}\n`
    changed = true
  }

  if (!content.includes('@utility shadow-input')) {
    content = `${content}\n${renderAdminShadowInputUtility()}\n`
    changed = true
  }

  if (changed) {
    fs.writeFileSync(cssFile, content, 'utf-8')
  }

  return { file: cssFile, appended: changed }
}
